import {connectService} from 'components/service/connectService'
import {Admin} from 'modules/admin/Admin'
import {useRef} from 'react'
import {useNavigate} from 'react-router-dom'
import {Roles, getInitials} from 'utility/utility'
import {Tooltip} from 'react-tooltip'

export const Distributors = connectService(
  props => {
    const navigate = useNavigate()

    const {list, loading, Loader, Placeholder, Paginator, rehydrate} = props
    const adminModalRef = useRef(null)

    return (
      <>
        <div className="table-responsive-mask">
          <div className="table-responsive">
            <table className="vw-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Admins</th>
                  <th>Details</th>
                  <th>&nbsp; </th>
                </tr>
              </thead>
              <tbody>
                {list.length ? (
                  list.map(item => (
                    <tr key={item._id} onClick={() => navigate(item._id)} className="pointer">
                      <td>
                        <div className="vw-table__name">
                          <div className="vw-table__name__no-img vw-icon-bg">{getInitials(item.name)}</div>{' '}
                          {item.name}
                        </div>
                      </td>

                      <td>
                        <ul className="vw-table__admins">
                          <li className="vw-table__admins__add">
                            <button
                              className="btn-add"
                              onClick={e => {
                                e.stopPropagation()
                                adminModalRef.current.show({
                                  adminOf: item._id,
                                  entity: 'distributor',
                                  distributor: item._id,
                                  permissions: [Roles.distributor]
                                })
                              }}
                            >
                              <i className="fal fa-plus"></i>
                            </button>
                          </li>

                          {item?.admins.length ? (
                            item.admins.map(admin => (
                              <li key={admin._id}>
                                <div className="vw-table__admins__no-img vw-icon-bg vw-icon-bg--j">
                                  {getInitials(`${admin.firstName} ${admin.lastName}`)}
                                </div>
                              </li>
                            ))
                          ) : (
                            <li>-</li>
                          )}
                        </ul>
                      </td>

                      <td>
                        <ul className="vw-table__details">
                          <li data-tooltip-id={`statistics-${item._id}-resellers`}>
                            {item?.statistics?.resellers} <i className="fal fa-user-friends"></i>
                            <Tooltip
                              id={`statistics-${item._id}-resellers`}
                              place="top"
                              content={`${item?.statistics?.resellers} Resellers`}
                            />
                          </li>
                          <li data-tooltip-id={`statistics-${item._id}-businesses`}>
                            {item?.statistics?.businesses} <i className="fal fa-user"></i>
                            <Tooltip
                              id={`statistics-${item._id}-businesses`}
                              place="top"
                              content={`${item?.statistics?.businesses} Businesses`}
                            />
                          </li>
                          <li data-tooltip-id={`statistics-${item._id}-groups`}>
                            {item?.statistics?.groups} <i className="fal fa-window-restore"></i>
                            <Tooltip
                              id={`statistics-${item._id}-groups`}
                              place="top"
                              content={`${item?.statistics?.groups} Groups`}
                            />
                          </li>
                          <li data-tooltip-id={`statistics-${item._id}-devices`}>
                            {item?.statistics?.devices} <i className="fal fa-window-maximize"></i>
                            <Tooltip
                              id={`statistics-${item._id}-devices`}
                              place="top"
                              content={`${item?.statistics?.devices} Devices`}
                            />
                          </li>
                        </ul>
                      </td>
                      <td>
                        <button
                          onClick={e => {
                            e.stopPropagation()
                            navigate(`${item._id}/reseller`)
                          }}
                          className="btn btn-primary"
                        >
                          View Resellers
                        </button>
                        {/* <Link to={`${item._id}`} className="btn btn-primary">
                        Edit
                      </Link> */}
                      </td>
                    </tr>
                  ))
                ) : loading ? (
                  <Loader colSpan={6} />
                ) : (
                  <Placeholder colSpan={6} placeholder="No Distributors" />
                )}
              </tbody>
            </table>
            <div className="vw-group-button">
              <button
                onClick={() => navigate('create')}
                className="btn btn-add btn-add--lg vw-tab-group-button"
              >
                <i className="fal fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <Admin ref={adminModalRef} onCreated={() => rehydrate()} />
        {Paginator({className: 'd-flex flex-row-reverse mt-2'})}
      </>
    )
  },
  'distributor',
  {
    query: {
      $sort: {name: 1}
    }
  }
)
